import { render, staticRenderFns } from "./UsersViewedReports.vue?vue&type=template&id=0978048e&scoped=true"
import script from "./UsersViewedReports.vue?vue&type=script&lang=js"
export * from "./UsersViewedReports.vue?vue&type=script&lang=js"
import style0 from "./UsersViewedReports.vue?vue&type=style&index=0&id=0978048e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0978048e",
  null
  
)

export default component.exports